<template>
  <b-row
    style="height: 100%"
    class="p-3"
  >
    <b-col cols="12">
      <span class="title">{{ $tc('configuration.modal.operation', 2) }}</span>
    </b-col>
    <b-col class="mt-2 tab-scroll-content without-footer association-table pl-0 pr-2 mx-2">
      <div class="d-flex mb-1 header-row">
        <div class="d-flex">
          <div class="fixed-column">
            <vt-input
              v-model="filter"
              class="form-control-sm"
              :placeholder="$t('configuration.modal.filterOperations')"
            />
          </div>
          <div class="check-column group d-flex align-items-center">
            <operation-group-filter
              :target-id="'userappModal'"
              @change="groupFilter = $event"
            />
          </div>
          <div
            v-for="(laboratory, index) in laboratories"
            :key="index"
            class="check-column d-flex align-items-center"
          >
            <span
              v-tooltip="laboratory.labName"
              class="pl-2"
            >{{ laboratory.labName }}</span>
          </div>
        </div>
      </div>
      <div
        v-for="(association, index) in filteredInternalOperationAssociations"
        :key="index"
        class="d-flex"
      >
        <div class="d-flex bottom-line">
          <div class="fixed-column">
            <span>{{ association[ASSOCIATION_TYPE.OPERATION.key].translatedName }}</span>
          </div>
          <div class="check-column group d-flex align-items-center">
            <span>
              <div class="d-flex">
                <div class="dark-color d-flex align-items-center justify-content-center">
                  <div class="group-icon">
                    <i
                      v-if="association[ASSOCIATION_TYPE.OPERATION.key].type === OPERATION_GROUP.ACCESS.value"
                      :class="OPERATION_GROUP.ACCESS.icon"
                      aria-hidden="true"
                    />
                    <i
                      v-else
                      :class="getOperationGroup(association[ASSOCIATION_TYPE.OPERATION.key]).icon"
                      aria-hidden="true"
                    />
                  </div>
                  <span v-if="association[ASSOCIATION_TYPE.OPERATION.key].type === OPERATION_GROUP.ACCESS.value">{{ OPERATION_GROUP.ACCESS.translatedName }}</span>
                  <span v-else>{{ getOperationGroup(association[ASSOCIATION_TYPE.OPERATION.key]).translatedName }}</span>
                </div>
              </div>
            </span>
          </div>
          <div
            v-for="(operationLab, indexOperationLab) in association.laboratories"
            :key="indexOperationLab"
            class="check-column d-flex align-items-center"
            :class="indexOperationLab"
          >
            <b-form-checkbox
              v-model="operationLab.assigned"
              :disabled="checkDisabled(operationLab, association)"
              class="ml-2"
              :class="{'disabled': checkDisabled(operationLab, association)}"
              @change="userappOperationChanged(operationLab, association)"
            />
            <i
              v-if="!operationLab.all && operationLab.assigned && getOperationAssociatedRoles(association[ASSOCIATION_TYPE.OPERATION.key], operationLab) !== ''"
              v-tooltip.html="`${$tc('configuration.modal.comeFromRole')}:${getOperationAssociatedRoles(association[ASSOCIATION_TYPE.OPERATION.key], operationLab)}`"
              style="cursor:pointer"
              class="main fas fa-exclamation"
              aria-hidden="true"
            />
          </div>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { ASSOCIATION_TYPE } from '@/api/resources/configuration/peopleManagement/AssociationTypes'
import { OPERATION_GROUP } from '@/api/resources/configuration/peopleManagement/OperationGroups'
import UserappOperationConfigurationServices from '@/api/resources/configuration/peopleManagement/userapp/UserappOperationConfigurationServices'
import OperationGroupFilter from '@/modules/configurationModule/detail/peopleManagement/OperationGroupFilter'

export default {
    name: 'UserappOperations',
    components: { OperationGroupFilter },
    props: {
        userappOperations: { type: Array },
        laboratories: { type: Array },
        userappId: { type: Number }
    },
    data() {
        return {
            filter: '',
            groupFilter: null
        }
    },
    computed: {
        filteredInternalOperationAssociations() {
            return this.userappOperations.filter(association => {
                if (this.groupFilter) {
                    if (this.groupFilter.value === this.OPERATION_GROUP.ACCESS.value) {
                        return association[this.ASSOCIATION_TYPE.OPERATION.key].translatedName.toLowerCase().includes(this.filter.toLowerCase()) &&
                            association[this.ASSOCIATION_TYPE.OPERATION.key].type === this.OPERATION_GROUP.ACCESS.value
                    }
                    if (this.groupFilter.value === this.OPERATION_GROUP.OTHERS.value) {
                        return association[this.ASSOCIATION_TYPE.OPERATION.key].translatedName.toLowerCase().includes(this.filter.toLowerCase()) &&
                            this.OPERATION_GROUP.OTHERS.groups.includes(association[this.ASSOCIATION_TYPE.OPERATION.key].group)
                    } else {
                        return association[this.ASSOCIATION_TYPE.OPERATION.key].translatedName.toLowerCase().includes(this.filter.toLowerCase()) &&
                            this.getOperationGroup(association[this.ASSOCIATION_TYPE.OPERATION.key]).value === this.groupFilter.value
                    }
                } else {
                    return association[this.ASSOCIATION_TYPE.OPERATION.key].translatedName.toLowerCase().includes(this.filter.toLowerCase())
                }
            })
        },
        ASSOCIATION_TYPE() {
            return ASSOCIATION_TYPE
        },
        OPERATION_GROUP() {
            return OPERATION_GROUP
        }
    },
    watch: {
        groupFilter() {
            this.$root.$emit('bv::hide::popover', 'operation-group-pop')
        }
    },
    methods: {
        getOperationGroup(associationOperation) {
            let operationGroup = ''
            let regExp = ''
            for (let operation in this.OPERATION_GROUP) {
                if (this.OPERATION_GROUP[operation].groups) {
                    this.OPERATION_GROUP[operation].groups.forEach(group => {
                        regExp = new RegExp('^' + associationOperation.group)
                        if (regExp.test(group)) operationGroup = this.OPERATION_GROUP[operation]
                    })
                }
            }
            return operationGroup
        },
        getOperationAssociatedRoles(operation, operationLab) {
            let textHtml = ''
            if (operationLab.roles) {
                operationLab.roles.forEach(operationLabRole => {
                    textHtml += `<p class="m-0 p-0">${operationLabRole.name}</p>`
                })
            }
            return textHtml
        },
        async allLabsUserappOperationChanged(allLabs, association) {
            let err = null
            let allOperationsLabs = null
            this.updateLoading(true)
            if (association.operation.global) {
                const allLab = association.laboratories.find(lab => lab.all)
                allOperationsLabs = association.laboratories[0]
                if (allLab.assigned) {
                    err = await this.createUserappOperation(allLab, association)
                } else {
                    err = await this.deleteUserappOperation(allLab, association)
                }
            } else {
                allOperationsLabs = association.laboratories.filter(lab => !lab.all && allLabs.assigned !== lab.assigned)
                for (const lab of allOperationsLabs) {
                    if (!lab.assigned) {
                        err = await this.createUserappOperation(lab, association)
                    } else {
                        err = await this.deleteUserappOperation(lab, association)
                    }
                }
            }
            this.updateLoading(false)
            return [err, allOperationsLabs]
        },
        async userappOperationChanged(lab, association) {
            let err = null
            let allOperationLabs = []
            if (lab.all) {
                [err, allOperationLabs] = await this.allLabsUserappOperationChanged(lab, association)
            } else {
                if (lab.assigned) {
                    err = await this.createUserappOperation(lab, association)
                } else err = await this.deleteUserappOperation(lab, association)
            }
            if (!err) {
                if (lab.all) {
                    if (lab.assigned) {
                        const operationsDeleted = allOperationLabs.filter(operationLab => operationLab.assigned).length
                        this.showToastSuccessGlobal(this.$tc('configuration.toastMessages.userappOperationCreated', operationsDeleted, { userappOperations: operationsDeleted }))
                    } else {
                        const operationsCreated = allOperationLabs.filter(operationLab => !operationLab.assigned).length
                        this.showToastSuccessGlobal(this.$tc('configuration.toastMessages.userappOperationDeleted', operationsCreated, { userappOperations: operationsCreated }))
                    }
                } else {
                    if (lab.assigned) {
                        this.showToastSuccessGlobal(this.$tc('configuration.toastMessages.userappOperationCreated', 1))
                    } else {
                        this.showToastSuccessGlobal(this.$tc('configuration.toastMessages.userappOperationDeleted', 1))
                    }
                }
            }
        },
        async createUserappOperation(lab, association) {
            const userappOperationCreateRequest = {
                userappId: this.userappId,
                laboratoryId: lab ? lab.labId : null,
                operationId: association.operation.id
            }
            const [err, response] = await this.toCall(UserappOperationConfigurationServices.createUserappOperation(userappOperationCreateRequest))
            if (err) {
                lab.assigned = false
                this.showErrorModalGlobal(err.message)
                return err
            }
            lab.assigned = true
            lab.userappOperationId = response.id
            const allLaboratory = association.laboratories.find(laboratory => laboratory.all)
            if (!allLaboratory.assigned) {
                const laboratories = association.laboratories.filter(laboratory => !laboratory.all).length
                const assignedLaboratories = association.laboratories.filter(laboratory => laboratory.assigned && !laboratory.all).length
                if (laboratories === assignedLaboratories) {
                    allLaboratory.assigned = true
                }
            }
        },
        async deleteUserappOperation(lab, association) {
            if (!lab.roles.length) {
                const [err] = await this.toCall(UserappOperationConfigurationServices.deleteUserappOperation(lab.userappOperationId))
                if (err) {
                    lab.assigned = true
                    this.showErrorModalGlobal(err.message)
                    return err
                }
                lab.assigned = false
                const allLaboratory = association.laboratories.find(laboratory => laboratory.all)
                if (allLaboratory.assigned) {
                    allLaboratory.assigned = false
                }
            }
        },
        checkDisabled(operationLab, association) {
            let disabled = false
            const laboratoriesOperationWithRoles = association.laboratories.filter(laboratory => laboratory.roles.length).length
            const laboratoriesOperation = association.laboratories.filter(laboratory => !laboratory.all).length
            if ((!operationLab.all && association[ASSOCIATION_TYPE.OPERATION.key].global) ||
                (operationLab.roles.length && operationLab.assigned) ||
                (operationLab.all && laboratoriesOperationWithRoles === laboratoriesOperation)) {
                disabled = true
            }
            return disabled
        }
    }
}
</script>

<style>
    .custom-control {
        z-index: 0;
    }
</style>
